export default "__VITE_ASSET__DVUiWlj2__"